<template>
  <Fragment>
    <transition name="fade" mode="out-in">
      <router-view @scroll="onScroll()" />
    </transition>
    <OverlayUI :route="this.activeRoute" />
  </Fragment>
</template>

<script>
import OverlayUI from "@/components/Layout/TopBar/OverlayUI";
import { Fragment } from "vue-fragment";
import AOS from "aos";
export default {
  name: "Layout",
  components: {
    OverlayUI,
    Fragment
  },
  methods: {
    onScroll() {
      AOS.refresh();
    }
  },
  data() {
    return {
      activeRoute: this.$route.name
    };
  },
  watch: {
    $route() {
      this.activeRoute = this.$route.name;
    }
  }
};
</script>

<style lang="scss">
.page__wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}
</style>